/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Comparison {
    EQUALS = 0,
    DOES_NOT_EQUAL = 1,
    CONTAINS = 2,
    DOES_NOT_CONTAIN = 3,
    GREATER_THAN = 4,
    LESS_THAN = 5,
    GREATER_THAN_OR_EQUAL_TO = 6,
    LESS_THAN_OR_EQUAL_TO = 7,
    STARTS_WITH = 8,
    DOES_NOT_START_WITH = 9,
    ENDS_WITH = 10,
    DOES_NOT_END_WITH = 11,
    EXISTS = 12,
    DOES_NOT_EXIST = 13,
    IS_TRUE = 14,
    IS_FALSE = 15,
}
